import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UserModel } from '@fi-app/user/user.model';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import {
    DataFieldEditPassword_Settings,
    DataFieldEditPasswordComponent,
    TDataFieldEditPassword_Settings,
} from '@fi-app/data-field/data-field-edit/password/password.component';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-user-edit-security-tab',
    templateUrl: './fi-user-edit-security-tab.component.html',
    styleUrls: ['./fi-user-edit-security-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-edit-security-tab' },
    providers: [
        {
            provide: DataFieldEditPassword_Settings,
            deps: [FiUserEditSecurityTabComponent],
            useFactory: (userEditComponent: FiUserEditSecurityTabComponent): TDataFieldEditPassword_Settings => ({
                isHiddenFunc: () => userEditComponent.isADLogin || userEditComponent.isPasswordHiddenForNewUser(),
                isRequiredFunc: () => userEditComponent.user.Id == 0 && !userEditComponent.isPasswordHiddenForNewUser(),
                onInit: (instance: DataFieldEditPasswordComponent) => {
                    userEditComponent.passwordComponentInstance = instance;
                },
                isShowSendMagicLinkFunc: () => userEditComponent.showSendMagicLink,
                isShowPasswordButtonShown: true,
                isResetPasswordButtonShown: true,
                isDividerShown: true,
            }),
        },
        { provide: FiComponentsContainer, useExisting: FiUserEditSecurityTabComponent },
    ],
    standalone: false,
})
export class FiUserEditSecurityTabComponent extends FiComponentsContainer implements OnInit {
    @Input() user: UserModel;
    @Input() dataFieldsPassword: DataFieldModel[] = [];
    @Input() isADLogin: boolean;
    @Input() isProfileMode: boolean;
    passwordComponentInstance: DataFieldEditPasswordComponent;
    showSendMagicLink: boolean;

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private userDataService: FiUserDataService,
        private appTextService: AppTextService,
    ) {
        super();
    }

    ngOnInit() {
        this._initMagicLink();
    }

    isPasswordHiddenForNewUser(): boolean {
        return !this.user.Id && this.user.SendMagicLink;
    }

    private _initMagicLink() {
        this.showSendMagicLink =
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.CoreLocal,
                AccessRightType.Write,
            ) &&
            !this.isADLogin &&
            !this.isProfileMode &&
            (!this.user.Id || this.user.IsAccessRequesting); // https://chainformation.atlassian.net/browse/FI-6056 show 'send login link only for new users and access requests'
        if (!this.user.Id && this.showSendMagicLink) this.user.SendMagicLink = true;
    }

    getPasswordSectionLabel(): string {
        return this.appTextService.get(this.user.Id ? 'common.change_password' : 'common.password');
    }
}
